import { Context } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import GenerateBillingReport from '../../views/billing/GenerateBillingReport';
export default {
  id: 'recovr.company.GenerateBillingReport',
  name: 'Generate Billing Report',
  matches: [{
    use: ['actionBar'],
    path: 'company',
    objectType: 'company',
    client: 'GroupScreen'
  }],
  handles: cxt => {
    const targets = Context.getTarget(cxt);
    if (!targets) {
      return false;
    }
    return true;
  },
  appearance: ({
    context
  }) => {
    return {
      name: 'Generate Billing Report',
      icon: 'https://storage.googleapis.com/recovr-ui-assets/generate_billing_icon_inactive.png'
    };
  },
  perform: data => {
    const {
      context
    } = data;
    const {
      clientProps
    } = context;
    const targetKey = clientProps.targetKey;
    const targets = Context.getTargets(context);
    const systemId = clientProps.actions.systemId;
    Dialogs.show({
      component: GenerateBillingReport,
      props: {
        targets,
        dispatch: context.clientProps.dispatch,
        reloadData: context.reloadData || clientProps.reloadData,
        targetKey,
        systemId
      }
    });
  }
};